import {
  COMMENT_REPLY_SET,
  COMMENT_REPLY_CANCEL
} from 'app/redux/constants/actionTypes';

const commentReply = {
  set: (values) => {
    return {type: COMMENT_REPLY_SET, values};
  },
  cancel: () => {
    return {type: COMMENT_REPLY_CANCEL};
  }
};

export default commentReply;